import { webKnots } from 'src/features/atoms/glove/drawer/common/back/lace/webKnots'
import { topSidePartOfWebWithJoint } from './parts/sideParts'
import { webToCatchFaceConnect } from '../lace/webToCatchFaceConnect'
import { webTops } from '../lace/webTop'
import { connectWebToIndex, connectWebToIndexTop, connectWebToThumb, connectWebToThumbTop } from '../lace/connectWebAndFinger'

export const joinOnePeaceWeb = (
  ctx: CanvasRenderingContext2D,
  webColorFirst: string,
  webColorSecond: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 0.8
  ctx.fillStyle = webColorFirst
  ctx.strokeStyle = '#282828'
  // ウェブパーツ
  ctx.beginPath()
  ctx.moveTo(576, 44) // 左上
  ctx.quadraticCurveTo(534, 103, 498, 211) // 左下
  ctx.quadraticCurveTo(561, 255, 605, 342) //右下
  ctx.quadraticCurveTo(630, 347, 635, 337) //
  ctx.quadraticCurveTo(703, 253, 721, 245) //右上
  ctx.quadraticCurveTo(625, 70, 576, 44) //左上
  ctx.fill()
  ctx.quadraticCurveTo(498, 211, 500, 212) // 左下の革紐の穴上部
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 横向き＿上
  ctx.moveTo(572, 60) // 左上
  ctx.quadraticCurveTo(659, 147, 708, 251) // 右下
  ctx.moveTo(570, 64) // 左上
  ctx.quadraticCurveTo(657, 151, 706, 255) // 右下
  // 中間の四角＿上辺
  ctx.moveTo(543, 124) // 左上
  ctx.quadraticCurveTo(626, 190, 662, 298) // 左下
  ctx.moveTo(540, 127) // 左上
  ctx.quadraticCurveTo(623, 194, 658, 300) // 左下
  // 中間の四角＿左辺
  ctx.moveTo(543, 125) // 左上
  ctx.quadraticCurveTo(526, 162, 527, 162) // 左下
  ctx.moveTo(540, 127) // 左上
  ctx.quadraticCurveTo(524, 163, 524, 163) // 左下
  // 中間の四角＿下辺
  ctx.moveTo(523, 160) // 左上
  ctx.quadraticCurveTo(617, 226, 645, 325) // 右下
  ctx.moveTo(520, 163) // 左上
  ctx.quadraticCurveTo(613, 229, 642, 328) // 右下
  // 中間の四角＿右辺
  ctx.moveTo(657, 300) // 左上
  ctx.quadraticCurveTo(638, 322, 638, 322) // 左下
  ctx.moveTo(662, 301) // 左上
  ctx.quadraticCurveTo(642, 325, 639, 325) // 左下

  // 横向き＿下
  ctx.moveTo(515, 178) // 左上
  ctx.quadraticCurveTo(605, 248, 632, 334) // 右下
  ctx.moveTo(512, 180) // 左上
  ctx.quadraticCurveTo(592, 240, 629, 331) // 右下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = '#282828'
  ctx.closePath()
  // stitchここまで

  // laceここから
  // 左上
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(567, 140) // 左上
  ctx.quadraticCurveTo(584, 171, 592, 193) //左下
  ctx.quadraticCurveTo(600, 205, 600, 190) //右下
  ctx.quadraticCurveTo(595, 159, 575, 138) //右上
  ctx.quadraticCurveTo(571, 133, 567, 140) //左上
  ctx.fill()
  ctx.moveTo(566, 137) // 左上
  ctx.quadraticCurveTo(583, 155, 594, 195) //左下
  ctx.stroke()
  ctx.closePath()

  // 左下
  ctx.beginPath()
  ctx.moveTo(546, 187) // 左上
  ctx.quadraticCurveTo(546, 198, 546, 198) //左下
  ctx.quadraticCurveTo(570, 210, 591, 215) //右下
  ctx.quadraticCurveTo(595, 210, 591, 204) //右上
  ctx.quadraticCurveTo(571, 198, 546, 187) //左上
  ctx.fill()
  ctx.moveTo(546, 196) // 左
  ctx.quadraticCurveTo(571, 208, 591, 213) //右
  ctx.stroke()
  ctx.closePath()

  // 右上
  ctx.beginPath()
  ctx.moveTo(617, 219) // 左上
  ctx.quadraticCurveTo(616, 228, 616, 227) //左下
  ctx.quadraticCurveTo(640, 242, 655, 268) //右下
  ctx.quadraticCurveTo(660, 263, 656, 256) //右上
  ctx.quadraticCurveTo(644, 230, 617, 219) //左上
  ctx.fill()
  ctx.moveTo(616, 227) //左下
  ctx.quadraticCurveTo(640, 236, 655, 268) //右下
  ctx.stroke()
  ctx.closePath()

  // 右下
  ctx.beginPath()
  ctx.moveTo(604, 232) // 左下
  ctx.quadraticCurveTo(613, 252, 615, 286) //右下
  ctx.quadraticCurveTo(618, 290, 623, 284) //右上
  ctx.quadraticCurveTo(625, 259, 613, 230) //左上
  ctx.quadraticCurveTo(608, 226, 604, 232) //左下
  ctx.fill()
  ctx.moveTo(605, 232) // 上
  ctx.quadraticCurveTo(618, 256, 615, 286) //下
  ctx.stroke()
  ctx.closePath()

  webToCatchFaceConnect(ctx, laceColor, -35, 17)
  webTops(ctx, laceColor, 20, 82) // 右＿親指から1番目
  webTops(ctx, laceColor, 15, 70) // 右＿親指から2番目
  webTops(ctx, laceColor, 5, 51) // 右＿親指から3番目
  webTops(ctx, laceColor, -7, 30) // 右＿親指から4番目
  webTops(ctx, laceColor, -20, 10) // 右＿親指から5番目
  webTops(ctx, laceColor, -33, -10) // 右＿親指から6番目
  webTops(ctx, laceColor, -45, -29) // 右＿親指から7番目
  webTops(ctx, laceColor, -58, -47) // 右＿親指から8番目
  webTops(ctx, laceColor, -70, -63) // 右＿親指から8番目
  webTops(ctx, laceColor, -85, -80) // 右＿親指から8番目
  webTops(ctx, laceColor, -100, -95) // 右＿親指から8番目

  connectWebToIndexTop(ctx, laceColor, 0, 0)
  connectWebToIndex(ctx, laceColor, 45, -92) //
  connectWebToIndex(ctx, laceColor, 10, -15) //
  connectWebToIndex(ctx, laceColor, -12, 38) //
  connectWebToThumbTop(ctx, laceColor, 0, 0)
  connectWebToThumbTop(ctx, laceColor, -10, 10)
  connectWebToThumb(ctx, laceColor, 60, 30) //
  connectWebToThumb(ctx, laceColor, 20, -25) //
  connectWebToThumb(ctx, laceColor, -5, 1) //
  webKnots(ctx, laceColor, -50, 50) // 捕球面寄りのウェブ結び目

  // web先端の革パーツ
  topSidePartOfWebWithJoint(ctx, webColorSecond, webColorFirst, laceColor, stitchColor)
}
